const INFO = {
	main: {
		title: "Jose Duque Dev",
		name: "Jose Duque",
		//email: "jmduquea23@gmail.com",
		logo: "../logo1.png",
	},

	socials: {
		twitter: "https://twitter.com/joseduquea",
		github: "https://github.com/joseduquea",
		linkedin: "https://www.linkedin.com/in/joseduquea/",
		paypal: "https://www.paypal.me/joseduquea",
		//instagram: "https://instagram.com/",
		//stackoverflow: "https://stackoverflow.com/",
		//facebook: "https://facebook.com/",
	},

	homepage: {
		title: "Desarrollador en Tecnologías Web Modernas",
		description:
			"Soy un desarrollador web en continuo aprendizaje hacia el Full Stack. Tengo experiencia en la construcción de aplicaciones web escalables, seguras y confiables utilizando varios marcos y tecnologías. Disfruto resolviendo problemas complejos y aprendiendo nuevas habilidades. Me apasiona crear código de alta calidad que siga las mejores prácticas y los estándares de la industria. Siempre estoy buscando nuevos desafíos y oportunidades para crecer como desarrollador.",
	},

	about: {
		title: "Hola 👋, soy José Duque",
		description:
			"Mi travesía como desarrollador me ha llevado por un largo camino que llena de satisfacción por los resultados obtenidos. Parte esencial de mi enfoque profesional se ha centrado en proyectos de código abierto, disponibles para la exploración y todos pueden acceder a ellos como una herramienta que pueden usar en su día a día.",
		secondDescription: "También me apasiona mucho el Fitness; de hecho, es uno de mis hobbies favoritos. Mi dedicación al mundo del desarrollo y la programación encuentra un equilibrio perfecto con mi amor por el fitness, ya que ambos aspectos requieren disciplina, perseverancia y la búsqueda constante de superación. Esta pasión por el bienestar físico y mental complementa mi enfoque en la resolución de problemas y la creación de soluciones, permitiéndome abordar desafíos desde diferentes perspectivas y enriquecer mi capacidad para colaborar eficazmente en equipos diversos."
	},

	/*articles: {
		title: "I'm passionate about pushing the boundaries of what's possible and inspiring the next generation of innovators.",
		description:
			"Chronological collection of my long-form thoughts on programming, leadership, product design, and more.",
	},*/

	projects: [
		{
			title: "Proyecto 1 - Journal APP",
			description:
				"Diario con CRUD, autenticación con Firebase y almacenamiento en FirestoreDB y Cloudinary.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			linkText: "Ver Proyecto",
			link: "https://journal-app-vite.netlify.app",
		},

		{
			title: "Proyecto 2 - Calendar APP",
			description:
				"Calendario MERN: Gestión de eventos con MongoDB, Express, React y Node para una experiencia eficiente.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			linkText: "Ver Proyecto",
			link: "https://project-calendar.up.railway.app/",
		},

		{
			title: "Proyecto 3 - Heroes SPA",
			description:
				"Sitio interactivo con React para explorar y aprender sobre diversos héroes.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			linkText: "Ver Proyecto",
			link: "https://heroes-app-yarn-vite.netlify.app",
		},

		{
			title: "Proyecto 4 - Gif Search",
			description:
				"Aplicación para encontrar y compartir todo tipo gifs con facilidad, impulsada por APIs.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			linkText: "Ver Proyecto",
			link: "https://gif-search-vite-react.netlify.app",
		},

		{
			title: "Proyecto 5 - ToDo SPA",
			description:
				"Organizador personal en React para tareas y listas con enfoque en usabilidad.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/html/html.png",
			linkText: "Ver Proyecto",
			link: "https://list-todo-app-yarn.netlify.app",
		},

		{
			title: "Más en mi GitHub",
			description:
				"Código fuente de los proyectos y más en mi perfil de GitHub",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/haskell/haskell.png",
			linkText: "Ir a GitHub",
			link: "https://github.com/joseduquea",
		},
	],
};

export default INFO;
